import { FEDEX_PRODUCTS } from "constants/carriers/fedex";

function getFedexDisplayData(productType) {
    switch (productType) {
        case FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY.serviceType: {
            return {
                originalName: FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY.originalName,
                name: FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY.friendlyName,
                isExpress: false,
                tags: [],
            };
        }
        case FEDEX_PRODUCTS.FEDEX_INTERNATIONAL_PRIORITY.oldServiceType: {
            return {
                originalName:
                    FEDEX_PRODUCTS.FEDEX_INTERNATIONAL_PRIORITY.originalName,
                name: FEDEX_PRODUCTS.FEDEX_INTERNATIONAL_PRIORITY.friendlyName,
                isExpress: true,
                tags: [],
            };
        }
        case FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY_FREIGHT.serviceType: {
            return {
                originalName:
                    FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY_FREIGHT.originalName,
                name: FEDEX_PRODUCTS.INTERNATIONAL_ECONOMY_FREIGHT.friendlyName,
                isExpress: false,
                tags: [],
            };
        }
        case FEDEX_PRODUCTS.INTERNATIONAL_PRIORITY_FREIGHT.serviceType: {
            return {
                originalName:
                    FEDEX_PRODUCTS.INTERNATIONAL_PRIORITY_FREIGHT.originalName,
                name: FEDEX_PRODUCTS.INTERNATIONAL_PRIORITY_FREIGHT
                    .friendlyName,
                isExpress: true,
                tags: [],
            };
        }
        case FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY.serviceType: {
            return {
                originalName:
                    FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY.originalName,
                name: FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY.friendlyName,
                isExpress: false,
                tags: [],
            };
        }
        case FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY_FREIGHT.serviceType: {
            return {
                originalName:
                    FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY_FREIGHT.originalName,
                name: FEDEX_PRODUCTS.FEDEX_REGIONAL_ECONOMY_FREIGHT
                    .friendlyName,
                isExpress: false,
                tags: [],
            };
        }
        default: {
            return {
                originalName: "Fedex",
                name: "Fedex",
                isExpress: false,
                tags: [],
            };
        }
    }
}

export { getFedexDisplayData };
